var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card-dialog-content" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.changeTabs },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _vm.$hasBtnRoles(_vm.rolePath(1))
            ? _c(
                "el-tab-pane",
                { attrs: { label: "装修风格", name: "1" } },
                [
                  _vm.activeName === "1"
                    ? _c("styleConfig", {
                        staticClass: "service-style-config",
                        attrs: { propInfo: _vm.decorInfo, disabled: true },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.$hasBtnRoles(_vm.rolePath(2))
            ? _c(
                "el-tab-pane",
                { attrs: { label: "首页装修", name: "2" } },
                [
                  _vm.activeName === "2"
                    ? _c("decorIndex", {
                        staticClass: "service-decor-index",
                        attrs: { propInfo: _vm.decorInfo, disabled: true },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.$hasBtnRoles(_vm.rolePath(3))
            ? _c(
                "el-tab-pane",
                { attrs: { label: "分类页装修", name: "3" } },
                [
                  _vm.activeName === "3"
                    ? _c("category", {
                        staticClass: "service-category",
                        attrs: { propInfo: _vm.decorInfo, disabled: true },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.$hasBtnRoles(_vm.rolePath(4))
            ? _c(
                "el-tab-pane",
                { attrs: { label: "高级设置", name: "4" } },
                [_c("adv-set", { attrs: { "adv-set": _vm.advSet } })],
                1
              )
            : _vm._e(),
          _vm.$hasBtnRoles(_vm.rolePath(5))
            ? _c(
                "el-tab-pane",
                { attrs: { label: "营销参数设置", name: "5" } },
                [
                  _c("market-set", {
                    attrs: {
                      module: _vm.module,
                      "market-set": _vm.marketSet,
                      "movie-list": _vm.movieList,
                      id: _vm.customerData.customer_id,
                      "account-id": _vm.customerData.account_id,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.$hasBtnRoles(_vm.rolePath(6))
            ? _c(
                "el-tab-pane",
                { attrs: { label: "个人中心", name: "6" } },
                [
                  _c("personal-center", {
                    attrs: { "person-data": _vm.personData },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.$hasBtnRoles(_vm.rolePath(7))
            ? _c(
                "el-tab-pane",
                { attrs: { label: "调价规则", name: "7" } },
                [
                  _c("kefu-adjust-rules", {
                    attrs: {
                      "goods-data": _vm.goodsData,
                      "menu-data": _vm.menuData,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }